import { NavItem } from "../nav-item/nav-item";

export const navItems: NavItem[] = [
    {
        navCap: 'Menú Club',
    },
    {
        displayName: 'Beneficios',
        iconName: 'gift',
        bgcolor: 'primary',
        route: '/club',
    },
    {
        displayName: 'Configuración',
        iconName: 'settings',
        bgcolor: 'primary',
        route: '/club/config',
    },
    {
        displayName: 'Notificaciones',
        iconName: 'bell',
        bgcolor: 'primary',
        route: '/club/notifications',
    },
];
